<template>
    <v-container fluid class="ma-0 pa-0">
        <v-toolbar :color="moduleColor" dense dark>
            <v-toolbar-title>
                <v-btn icon>
                    <v-icon class="mr-1 pulsing">mdi-chevron-up</v-icon>
                </v-btn>
                Driver Shifts
            </v-toolbar-title>

            <!-- Date Picker -->
            <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
                min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn text v-bind="attrs" v-on="on" class="ml-2" :loading="loading">
                        {{ displayDate }}
                        <v-icon right>mdi-calendar</v-icon>
                    </v-btn>
                </template>
                <v-date-picker v-model="computedSelectedDate" @input="closeDateMenu"></v-date-picker>
            </v-menu>

            <!-- Shift Period Toggle -->
            <v-btn-toggle v-model="computedShiftPeriod" dense :color="moduleColor + ' lighten-5'" group mandatory>
                <v-btn value="AM">AM</v-btn>
                <v-btn value="PM">PM</v-btn>
            </v-btn-toggle>

            <v-spacer></v-spacer>

            <v-toolbar-items>
                <!-- Refresh Button -->
                <v-btn icon @click="refresh" :loading="loading" :disabled="loading">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <!-- Refresh Button -->
                <v-btn icon @click="possibleHml" :loading="loading" :disabled="loading">
                    <v-icon>mdi-home-map-marker</v-icon>
                </v-btn>
                
                <!-- Refresh Button -->
                <v-btn icon @click="possibleMiddle" :loading="loading" :disabled="loading">
                    <v-icon>mdi-format-align-middle</v-icon>
                </v-btn>
                
                <!-- Menu with other actions -->
                <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" :loading="loading" :disabled="loading">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="(item, index) in menuItems" :key="index" @click="item.action" v-if="item.view == 0">
                            <v-list-item-title>
                                <v-icon left>{{ item.icon }}</v-icon>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <v-toolbar :color="moduleColor + ' lighten-2'" flat dense>
            <v-toolbar-items class="mt-2">
                <v-select v-model="computedSelectedRegion" solo flat dense hide-details :items="regions"
                    prepend-inner-icon="mdi-map-search" class="mr-2" style="max-width: 200px;"></v-select>
                <v-text-field v-model="computedSearch" solo flat dense hide-details prepend-inner-icon="mdi-magnify"
                    placeholder="Search Shift" style="max-width: 200px;"></v-text-field>
            </v-toolbar-items>
        </v-toolbar>
        <ShortLoads v-if="vDialogLoads" :vDialogLoads="vDialogLoads" :LoadsInfo="LoadsInfo"
            @close="vDialogLoads = false;">
        </ShortLoads>
        <showmiddle v-if="vDialogLoadMiddle" :vDialogLoadMiddle="vDialogLoadMiddle" 
        :LoadsInfoMiddle="LoadsInfoMiddle"
        @close="vDialogLoadMiddle = false;"></showmiddle>
    </v-container>
</template>

<script>
import ShortLoads from '../../Modals/Dispatch/Dispatch/Order/ShowLoads.vue';
import showmiddle from '../../Modals/Dispatch/Dispatch/Order/ShowLoadsMiddle.vue';
import axios from 'axios';
export default {
    name: 'ShiftToolbar',
    props: {
        moduleColor: String,
        selectedDate: String,
        shiftPeriod: String,
        loading: Boolean,
        menuItems: Array,
        selectedRegion: Number,
        search: String,
    },
    components:{
      ShortLoads,
      showmiddle
    },
    data() {
        return {
            vDialogLoadMiddle:false,
            LoadsInfo: null,
            vDialogLoads: false,
            LoadsInfoMiddle:null,
            dateMenu: false, // To control date picker menu
            regions: [
                {
                    text: 'All Regions',
                    value: 0
                },
                {
                    text: 'East Region',
                    value: 1
                },
                {
                    text: 'GTA',
                    value: 2
                },
                {
                    text: 'West Region',
                    value: 3
                }
            ]
        };
    },
    computed: {
        // Computed property for selectedDate with getter and setter
        computedSelectedDate: {
            get() {
                return this.selectedDate;
            },
            set(newDate) {
                this.$emit('update-date', newDate);
            }
        },
        // Computed property for shiftPeriod with getter and setter
        computedShiftPeriod: {
            get() {
                return this.shiftPeriod;
            },
            set(newPeriod) {
                this.$emit('update-shift-period', newPeriod);
            }
        },
        computedSelectedRegion: {
            get() {
                return this.selectedRegion;
            },
            set(newRegion) {
                this.$emit('update-region', newRegion);
            }
        },
        computedSearch: {
            get() {
                return this.search;
            },
            set(newSearch) {
                this.$emit('update-search', newSearch);
            }
        },
        displayDate() {
            // Format the date to display in the button
            return this.computedSelectedDate;
        }
    },
    methods: {
        // Emits the refresh event
        refresh() {
            this.$emit('refresh');
        },
        closeDateMenu() {
            this.dateMenu = false;
        },
        possibleHml: async function () {
            const shiftDetail = await prompt("Enter an ShiftDetail Number");
            if (shiftDetail) {
                this.$store.state.isLoading = true;
                axios
                    .get('short/loads/' + shiftDetail)
                    .then(response => {
                        console.log(response.data);
                        this.LoadsInfo = response.data;
                        this.vDialogLoads = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        possibleMiddle: async function () {
            const shiftDetail = await prompt("Enter an ShiftDetail Number");
            if (shiftDetail) {
                this.$store.state.isLoading = true;
                axios
                    .get('short/loads/middle/' + shiftDetail)
                    .then(response => {
                        console.log(response.data);
                        this.LoadsInfoMiddle = response.data;
                        this.vDialogLoadMiddle = true;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.$store.state.isLoading = false;
                    });
            }
        },
        // 
        viewOrder:async function (ord) {
            const orderNum = await prompt("Enter an Order Number");
            if (orderNum) {
            this.$store.state.isLoading = true;
            axios
                .get('short/shifts/' + orderNum + '/' + this.$store.state.shiftId.ShiftId)
                .then(response => {
                    console.log(response.data);
                    this.ShiftsInfo = response.data;
                    this.vDialogShifts = true;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.$store.state.isLoading = false;
                });
            } 
        },
    }
};
</script>
